import { createFeatureSelector, createSelector } from '@ngrx/store';

import { adapter } from './feed-advice.reducer';
import { ProductType } from '../../shared/models';
import { FeedAdviceModuleState } from '../models/feed-advice.model';

const { selectAll } = adapter.getSelectors();

export const getFeedAdviceModuleState =
  createFeatureSelector<FeedAdviceModuleState>('feedAdviceModule');
export const getFeedAdvicesState = createSelector(
  getFeedAdviceModuleState,
  (state) => state.feedAdvices,
);

export const getFeedAdvices = createSelector(getFeedAdvicesState, selectAll);
export const getProducts = createSelector(getFeedAdviceModuleState, (state) => state.products);
export const getActiveProducts = createSelector(getFeedAdviceModuleState, (state) =>
  state.products?.filter((p) => p.isActive && p.type === ProductType.Feed),
);
export const getActiveAdditives = createSelector(getFeedAdviceModuleState, (state) =>
  state.products?.filter((p) => p.isActive && p.type === ProductType.Additive),
);
export const getReferenceSchemes = createSelector(getFeedAdviceModuleState, (state) =>
  state.referenceSchemes?.filter((r) => r.isActive),
);
export const getBaseFeedAdvice = createSelector(
  getFeedAdviceModuleState,
  (state) => state.baseFeedAdvice,
);
